import React from 'react';
import Logo from "../Components/Logo";
import { useEffect } from 'react';
import { useNavigate , useSearchParams } from 'react-router-dom';


export default function Splash(props) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    useEffect(() => {
        const mobile = window.localStorage.getItem("mobile");

        if(searchParams.get('mobile') && searchParams.get('mobile') !== mobile) {
            document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            window.localStorage.setItem("mobile", searchParams.get('mobile'));
            window.localStorage.setItem("_mX2L", 'bAXfY');
        }

        const timeoutId = setTimeout(() => {
            const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
            const token = match ? match[2] : null;
            if(token) {
                if(window.localStorage.getItem("needRegistration")){
                    navigate('/home');
                    return;
                }

            }
           navigate('/login');
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash " >

                <div className="row">
                    <div className="col-12 ">
                        <Logo size={200} />
                    </div>
                    <h2 className="col-12 text-center mt-4 title text-secondary fw-bold">

                        سامانه هوشند ردیاب وسایل نقلیه
                    </h2>
                    <h6 className="col-12 text-center mt-4 text-muted text-small-1">

                    </h6>
                    <div className="col-12 text-center fixed-bottom mb-3">
                        <div className="spinner-grow text-muted" role="status">

                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
